(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fc-info-tip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fc-info-tip')) {
    customElements.define('fc-info-tip', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.fc-tip__btn');
        this.panel = this.querySelector('.fc-tip__panel');
        if (!this.btn || !this.panel) return;
        this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.btn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (this.hoverable) { this.open(); return; }
          this.isOpen() ? this.close() : this.open();
        });
        if (this.hoverable) {
          this.addEventListener('mouseenter', () => this.open());
          this.addEventListener('mouseleave', () => this.close());
        }
        this.onDoc = (e) => { if (!this.contains(e.target)) this.close(); };
        this.onKey = (e) => { if (e.key === 'Escape') { this.close(); this.btn.focus(); } };
        this.onOther = (e) => { if (e.detail !== this) this.close(); };
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('fc-tip:open', this.onOther);
        window.addEventListener('resize', () => this.close());
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('fc-tip:open', this.onOther);
      }
      isOpen() { return this.panel && !this.panel.hidden; }
      open() {
        if (this.isOpen()) return;
        document.dispatchEvent(new CustomEvent('fc-tip:open', { detail: this }));
        this.panel.style.setProperty('--fc-tip-shift', '0px');
        this.panel.hidden = false;
        this.btn.setAttribute('aria-expanded', 'true');
        const r = this.panel.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const m = 16;
        let shift = 0;
        if (r.left < m) shift = m - r.left;
        else if (r.right > vw - m) shift = vw - m - r.right;
        this.panel.style.setProperty('--fc-tip-shift', shift + 'px');
      }
      close() {
        if (!this.isOpen()) return;
        this.panel.hidden = true;
        this.btn.setAttribute('aria-expanded', 'false');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-dimensions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fc-dimensions')) {
    customElements.define('fc-dimensions', class extends HTMLElement {
      connectedCallback() {
        this.onVariant = (event) => {
          const html = event.detail && event.detail.data && event.detail.data.html;
          if (!html) return;
          const fresh = html.querySelector(`fc-dimensions[data-block-id="${this.dataset.blockId}"]`);
          if (!fresh) return;
          this.innerHTML = fresh.innerHTML;
          this.hidden = fresh.hasAttribute('hidden');
        };
        document.addEventListener('variant:updated', this.onVariant);
      }
      disconnectedCallback() {
        document.removeEventListener('variant:updated', this.onVariant);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
